module.exports = __webpack_public_path__ + "static/media/beep-07.6bb58878.wav";